import { render, staticRenderFns } from "./searchScore.vue?vue&type=template&id=b6803874&scoped=true&"
import script from "./searchScore.vue?vue&type=script&lang=js&"
export * from "./searchScore.vue?vue&type=script&lang=js&"
import style0 from "./searchScore.vue?vue&type=style&index=0&id=b6803874&prod&lang=scss&"
import style1 from "./searchScore.vue?vue&type=style&index=1&id=b6803874&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6803874",
  null
  
)

export default component.exports